export const TUTORIAL_STORAGE_KEY = 'bb_tutorial_progress_v4';
export const TUTORIAL_COMPLETE_KEY = 'bb_tutorial';
export const TUTORIAL_VERSION = 4 as const;
